// ABOUTME: The space the runner frame keeps clear under the scene host for the fixed plate.
// ABOUTME: The frame pads its bottom by it, and the breathing scene runs its sea down through it so the plate floats over water.
// ABOUTME: A tall plate (a phone) reaches above it; plateOverhangPx says by how much, for a scene that keeps its content clear.

export const RUNNER_PLATE_CLEARANCE_PX = 140;

// How far the plate floats above the bottom of the page, and how far on 1A. A phone docks it at the bottom (0).
export const RUNNER_PLATE_BOTTOM_PX = 18;
export const RUNNER_PLATE_FIRST_SCREEN_BOTTOM_PX = 31;
// The gap kept between the scene's content and the plate's top edge.
export const RUNNER_PLATE_GAP_PX = 8;

// How far the plate reaches above the clearance the frame already keeps, so a scene can pad its own content clear of it.
export function plateOverhangPx(plateHeightPx: number): number {
  return Math.max(0, plateHeightPx + RUNNER_PLATE_BOTTOM_PX + RUNNER_PLATE_GAP_PX - RUNNER_PLATE_CLEARANCE_PX);
}
